var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLegacyReport = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4.46426e-08H13.7295C14.5438 -0.000138815 15.3247 0.323668 15.9 0.9L20.127 5.133C20.6844 5.68991 20.9983 6.44506 21 7.233V21C21 22.6569 19.6569 24 18 24H4.5C2.84315 24 1.5 22.6569 1.5 21V3C1.5 1.34315 2.84315 4.46426e-08 4.5 4.46426e-08ZM14.838 1.959C14.5444 1.66449 14.1454 1.49928 13.7295 1.5H13.5H4.5C3.67157 1.5 3 2.17157 3 3V21C3 21.8284 3.67157 22.5 4.5 22.5H18C18.8284 22.5 19.5 21.8284 19.5 21V7.239C19.5017 6.84512 19.3456 6.46696 19.0665 6.189L14.838 1.959ZM15 15H10.5V6H7.5V18H10.5H15V15Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLegacyReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/legacy-report.25ef71c13028f295365b6ad3e1c51ce2.svg";